import React from 'react';
import {
    Grid,
    Typography,
    Card as MuiCard,
    Button,
    Accordion,
    AccordionSummary as MuiAccordionSummary,
    AccordionDetails,
    Box,
    TextField,
    IconButton,
} from "@mui/material";
import { Trash2 as Trash } from 'react-feather'
import { spacing } from "@mui/system";
import { ExpandMore as ExpandMoreIcon } from "@mui/icons-material";
import styled from "styled-components/macro";

const Card = styled(MuiCard)(spacing);

const AccordionSummary = styled(MuiAccordionSummary)`
  min-height: 64px;
  padding-left: 16px;
  background: ${(props) => props.theme.seasPalette.blue};
  color: #FFF;
`;

type DeviceSettingsProps = {
    title: string,
    expanded: boolean,
    deviceList: string[],
    notifySettingsChanged: (devices: string[]) => void,
}
const DeviceSettings: React.FC<DeviceSettingsProps> = ({
    title,
    expanded,
    deviceList,
    notifySettingsChanged
}) => {
    deviceList = deviceList || [];
    const [expandedPanel, setExpandedPanel] = React.useState(expanded);
    const handleAccordionChange = (panel: boolean) => (event: any, isExpanded: any) => {
        setExpandedPanel(isExpanded ? panel : false);
    };

    const [devices, setDevices] = React.useState(deviceList);
    const addDevice = (event: React.ChangeEvent<any>) => {
        let newState;
        newState = [ ...devices, '' ];
        setDevices(newState);
        notifySettingsChanged(newState);
    }
    const removeDevice = (index: number) => async (event: React.ChangeEvent<any>) => {
        let newState;
        newState = [ ...devices.slice(0, index),  ...devices.slice(index + 1)];
        setDevices(newState);
        notifySettingsChanged(newState);
    }
    const handleMetricChange = async (event: React.ChangeEvent<any>) => {
        const { target: { name, value } } = event;
        let newState;
        let index = parseInt(name);
        newState = [ ...devices.slice(0, index), value, ...devices.slice(index + 1)];
        setDevices(newState);
        notifySettingsChanged(newState);
    }

    const deviceComponents = devices.map((device, index) => {
        return (
            <Grid container spacing={6} key={index}>
                <Grid item xs={11} sm={6}>
                    <Box
                        component="form"
                            sx={{
                                '& > :not(style)': { 
                                    m: 1, 
                                    width: {
                                        xs: '96%'
                                    }
                                },
                            }}
                        noValidate
                        autoComplete="off" >
                        <TextField
                            id={"device"+index}
                            value={device}
                            onChange={handleMetricChange}
                            size="small"
                            name={''+index} />
                    </Box>
                </Grid>
                <Grid item xs={1}>
                    <IconButton 
                        disabled={index === 0 && devices.length === 1}
                        aria-label="delete"  
                        onClick={removeDevice(index)}>
                        <Trash />
                    </IconButton>
                </Grid>
            </Grid>
        )
    })
    return (
        <React.Fragment>
            <Card>
                <Accordion
                    expanded={expandedPanel}
                    onChange={handleAccordionChange(!expandedPanel)} >
                    <AccordionSummary
                        expandIcon={<ExpandMoreIcon sx={{ color: "#FFF"}}/>} >
                        <Typography variant="h5">
                            { title }
                        </Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                        { deviceComponents }
                        <Typography variant='h6'>
                            <Button size='large' onClick={addDevice}>+ Add Device</Button>
                        </Typography>
                    </AccordionDetails>
                </Accordion>
            </Card>
        </React.Fragment>
    )
};

export default DeviceSettings;